import { useEffect, useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container, Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import PaymentsListResults from 'src/components/payments/PaymentsListResults';
import PaymentsToolBar from 'src/components/payments/PaymentsToolBar';
import WasherLedgerKpis from 'src/components/payments/WasherLedgerKpis';
import WasherKitDeductions from 'src/components/payments/WasherKitDeductions';
import WasherAddMovementCard from 'src/components/payments/WasherAddMovementCard';
import { api } from 'src/service';
import { usePersistedPagerInfo } from 'src/utils/usePersistedLimit';

const Payments = () => {
  const [payments, setPayments] = useState();
  const [kpis, setKpis] = useState();
  const [loading, setLoading] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);
  const [pagerInfo, setPagerInfo] = usePersistedPagerInfo('paymentsByWasher', { limit: 10 });
  const params = useParams();

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        await api
          .get(`/paymentwasher/ledger/${params.washerId}`, {
            params: {
              page_size: pagerInfo.limit,
              current_page: pagerInfo.page,
              search: searchStr,
            },
          })
          .then((res) => {
            setPayments(res.data.data.data);
            setKpis(res.data.data.kpis);
            setPagerInfo({
              limit: res.data.data.page_size,
              page: res.data.data.current_page,
              totalSize: res.data.data.total_size,
            });
          });
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    };

    fetchData();
  }, [searchStr, pagerInfo.page, pagerInfo.limit, params.washerId, refreshKey]);

  const handleSearchStr = (str) => {
    setSearchStr(str);
  };

  const handlePagerInfo = (info) => {
    setPagerInfo(info);
  };

  const handleMovementAdded = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  return (
    <>
      <Helmet>
        <title>Washer - Payments</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <PaymentsToolBar
            handleSearchStr={handleSearchStr}
            id={params.washerId}
          />
          <Box sx={{ pt: 3 }}>
            <PaymentsListResults
              payments={payments}
              handlePagerInfo={handlePagerInfo}
              pagerInfo={pagerInfo}
              loading={loading}
            />
          </Box>
          <Box sx={{ pt: 3 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <WasherLedgerKpis kpis={kpis} loading={loading} />
              </Grid>
              <Grid item xs={12} md={3}>
                <WasherKitDeductions
                  washerId={params.washerId}
                  refreshKey={refreshKey}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <WasherAddMovementCard
                  washerId={params.washerId}
                  onAdded={handleMovementAdded}
                />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Payments;
